"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _Button = _interopRequireDefault(require("react-bootstrap/Button"));
var _FormControl = _interopRequireDefault(require("react-bootstrap/FormControl"));
var _InputGroup = _interopRequireDefault(require("react-bootstrap/InputGroup"));
var _Overlay = _interopRequireDefault(require("react-bootstrap/Overlay"));
var _Popover = _interopRequireDefault(require("react-bootstrap/Popover"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _createReactClass = _interopRequireDefault(require("create-react-class"));
var _styledComponents = require("styled-components");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var instanceCount = 0;
var CalendarHeader = (0, _createReactClass.default)({
  displayName: "DatePickerHeader",
  propTypes: {
    displayDate: _propTypes.default.object.isRequired,
    minDate: _propTypes.default.string,
    maxDate: _propTypes.default.string,
    onChange: _propTypes.default.func.isRequired,
    monthLabels: _propTypes.default.array.isRequired,
    previousButtonElement: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired,
    nextButtonElement: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired
  },
  displayingMinMonth: function displayingMinMonth() {
    if (!this.props.minDate) return false;
    var displayDate = new Date(this.props.displayDate);
    var minDate = new Date(this.props.minDate);
    return minDate.getFullYear() === displayDate.getFullYear() && minDate.getMonth() === displayDate.getMonth();
  },
  displayingMaxMonth: function displayingMaxMonth() {
    if (!this.props.maxDate) return false;
    var displayDate = new Date(this.props.displayDate);
    var maxDate = new Date(this.props.maxDate);
    return maxDate.getFullYear() === displayDate.getFullYear() && maxDate.getMonth() === displayDate.getMonth();
  },
  handleClickPrevious: function handleClickPrevious() {
    var newDisplayDate = new Date(this.props.displayDate);
    newDisplayDate.setDate(1);
    newDisplayDate.setMonth(newDisplayDate.getMonth() - 1);
    this.props.onChange(newDisplayDate);
  },
  handleClickNext: function handleClickNext() {
    var newDisplayDate = new Date(this.props.displayDate);
    newDisplayDate.setDate(1);
    newDisplayDate.setMonth(newDisplayDate.getMonth() + 1);
    this.props.onChange(newDisplayDate);
  },
  render: function render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "text-center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "text-muted pull-left datepicker-previous-wrapper",
      onClick: this.handleClickPrevious,
      style: {
        cursor: "pointer"
      }
    }, this.displayingMinMonth() ? null : this.props.previousButtonElement), /*#__PURE__*/_react.default.createElement("span", null, this.props.monthLabels[this.props.displayDate.getMonth()], " ", this.props.displayDate.getFullYear()), /*#__PURE__*/_react.default.createElement("div", {
      className: "text-muted pull-right datepicker-next-wrapper",
      onClick: this.handleClickNext,
      style: {
        cursor: "pointer"
      }
    }, this.displayingMaxMonth() ? null : this.props.nextButtonElement));
  }
});
var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var Calendar = (0, _createReactClass.default)({
  displayName: "DatePickerCalendar",
  propTypes: {
    selectedDate: _propTypes.default.object,
    displayDate: _propTypes.default.object.isRequired,
    minDate: _propTypes.default.string,
    maxDate: _propTypes.default.string,
    onChange: _propTypes.default.func.isRequired,
    dayLabels: _propTypes.default.array.isRequired,
    cellPadding: _propTypes.default.string.isRequired,
    weekStartsOn: _propTypes.default.number,
    showTodayButton: _propTypes.default.bool,
    todayButtonLabel: _propTypes.default.string,
    roundedCorners: _propTypes.default.bool,
    showWeeks: _propTypes.default.bool,
    isOverlayRightAligned: _propTypes.default.bool
  },
  handleClick: function handleClick(e) {
    var day = e.currentTarget.getAttribute("data-day");
    var newSelectedDate = this.setTimeToNoon(new Date(this.props.displayDate));
    newSelectedDate.setDate(day);
    this.props.onChange(newSelectedDate);
  },
  handleClickToday: function handleClickToday() {
    var newSelectedDate = this.setTimeToNoon(new Date());
    this.props.onChange(newSelectedDate);
  },
  setTimeToNoon: function setTimeToNoon(date) {
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  },
  getWeekNumber: function getWeekNumber(date) {
    var target = new Date(date.valueOf());
    var dayNr = (date.getDay() + 6) % 7;
    target.setDate(target.getDate() - dayNr + 3);
    var firstThursday = target.valueOf();
    target.setMonth(0, 1);
    if (target.getDay() !== 4) {
      target.setMonth(0, 1 + (4 - target.getDay() + 7) % 7);
    }
    return 1 + Math.ceil((firstThursday - target) / 604800000);
  },
  render: function render() {
    var _this = this;
    var currentDate = this.setTimeToNoon(new Date());
    var selectedDate = this.props.selectedDate ? this.setTimeToNoon(new Date(this.props.selectedDate)) : null;
    var minDate = this.props.minDate ? this.setTimeToNoon(new Date(this.props.minDate)) : null;
    var maxDate = this.props.maxDate ? this.setTimeToNoon(new Date(this.props.maxDate)) : null;
    var year = this.props.displayDate.getFullYear();
    var month = this.props.displayDate.getMonth();
    var firstDay = new Date(year, month, 1);
    var startingDay = this.props.weekStartsOn > 1 ? firstDay.getDay() - this.props.weekStartsOn + 7 : this.props.weekStartsOn === 1 ? firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1 : firstDay.getDay();
    var showWeeks = this.props.showWeeks;
    var monthLength = daysInMonth[month];
    if (month === 1) {
      if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
        monthLength = 29;
      }
    }
    var weeks = [];
    var day = 1;
    for (var i = 0; i < 9; i++) {
      var week = [];
      for (var j = 0; j <= 6; j++) {
        if (day <= monthLength && (i > 0 || j >= startingDay)) {
          var className = null;
          var date = new Date(year, month, day, 12, 0, 0, 0).toISOString();
          var beforeMinDate = minDate && Date.parse(date) < Date.parse(minDate);
          var afterMinDate = maxDate && Date.parse(date) > Date.parse(maxDate);
          var clickHandler = this.handleClick;
          var style = {
            cursor: "pointer",
            padding: this.props.cellPadding,
            borderRadius: this.props.roundedCorners ? 5 : 0
          };
          if (beforeMinDate || afterMinDate) {
            className = "text-muted";
            clickHandler = null;
            style.cursor = "default";
          } else if (Date.parse(date) === Date.parse(selectedDate)) {
            className = "selected-date-background";
          } else if (Date.parse(date) === Date.parse(currentDate)) {
            className = "selected-date-text";
          }
          week.push( /*#__PURE__*/_react.default.createElement("td", {
            key: j,
            "data-day": day,
            onClick: clickHandler,
            style: style,
            className: className
          }, day));
          day++;
        } else {
          week.push( /*#__PURE__*/_react.default.createElement("td", {
            key: j
          }));
        }
      }
      if (showWeeks) {
        var weekNum = this.getWeekNumber(new Date(year, month, day - 1, 12, 0, 0, 0));
        week.unshift( /*#__PURE__*/_react.default.createElement("td", {
          key: 7,
          style: {
            padding: this.props.cellPadding,
            fontSize: "0.8em",
            color: "darkgrey"
          },
          className: "text-muted"
        }, weekNum));
      }
      weeks.push( /*#__PURE__*/_react.default.createElement("tr", {
        key: i
      }, week));
      if (day > monthLength) {
        break;
      }
    }
    var weekColumn = showWeeks ? /*#__PURE__*/_react.default.createElement("td", {
      className: "text-muted current-week",
      style: {
        padding: this.props.cellPadding
      }
    }) : null;
    return /*#__PURE__*/_react.default.createElement("table", {
      className: "text-center"
    }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, weekColumn, this.props.dayLabels.map(function (label, index) {
      return /*#__PURE__*/_react.default.createElement("td", {
        key: index,
        className: "text-muted",
        style: {
          padding: _this.props.cellPadding
        }
      }, /*#__PURE__*/_react.default.createElement("small", null, label));
    }))), /*#__PURE__*/_react.default.createElement("tbody", null, weeks), this.props.showTodayButton && /*#__PURE__*/_react.default.createElement("tfoot", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
      colSpan: this.props.dayLabels.length,
      style: {
        paddingTop: "9px"
      }
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      block: true,
      bsSize: "xsmall",
      bsPrefix: "today-button",
      onClick: this.handleClickToday
    }, this.props.todayButtonLabel)))));
  }
});
var CustomDatePicker = (0, _createReactClass.default)({
  displayName: "DatePicker",
  propTypes: {
    defaultValue: _propTypes.default.string,
    value: _propTypes.default.string,
    popOverArrowLeft: _propTypes.default.string,
    required: _propTypes.default.bool,
    className: _propTypes.default.string,
    style: _propTypes.default.object,
    minDate: _propTypes.default.string,
    maxDate: _propTypes.default.string,
    cellPadding: _propTypes.default.string,
    autoComplete: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    dayLabels: _propTypes.default.array,
    monthLabels: _propTypes.default.array,
    onChange: _propTypes.default.func,
    onClear: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    onFocus: _propTypes.default.func,
    autoFocus: _propTypes.default.bool,
    disabled: _propTypes.default.bool,
    weekStartsOnMonday: function weekStartsOnMonday(props, propName, componentName) {
      if (props[propName]) {
        return new Error("Prop '".concat(propName, "' supplied to '").concat(componentName, "' is obsolete. Use 'weekStartsOn' instead."));
      }
    },
    weekStartsOn: _propTypes.default.number,
    clearButtonElement: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
    showClearButton: _propTypes.default.bool,
    previousButtonElement: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
    nextButtonElement: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
    calendarPlacement: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
    dateFormat: _propTypes.default.string,
    // 'MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD', 'DD-MM-YYYY'
    bsClass: _propTypes.default.string,
    bsSize: _propTypes.default.string,
    calendarContainer: _propTypes.default.object,
    id: _propTypes.default.string,
    name: _propTypes.default.string,
    showTodayButton: _propTypes.default.bool,
    todayButtonLabel: _propTypes.default.string,
    instanceCount: _propTypes.default.number,
    customControl: _propTypes.default.object,
    roundedCorners: _propTypes.default.bool,
    showWeeks: _propTypes.default.bool,
    children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
    onInvalid: _propTypes.default.func,
    noValidate: _propTypes.default.bool
  },
  componentDidMount: function componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
  },
  componentWillUnmount: function componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  },
  handleOutsideClick: function handleOutsideClick(event) {
    if (this.datePickerRef && !this.datePickerRef.contains(event.target)) {
      this.setState({
        focused: false
      });
    }
  },
  getDefaultProps: function getDefaultProps() {
    var language = typeof window !== "undefined" && window.navigator ? (window.navigator.userLanguage || window.navigator.language || "").toLowerCase() : "";
    var dateFormat = !language || language === "en-us" ? "MM/DD/YYYY" : "DD/MM/YYYY";
    return {
      cellPadding: "5px",
      dayLabels: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      monthLabels: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      popoverRight: '',
      popoverLeft: '',
      verticalPlacement: 'bottom',
      position: 'left',
      clearButtonElement: "×",
      previousButtonElement: "<",
      nextButtonElement: ">",
      calendarPlacement: "bottom",
      dateFormat: dateFormat,
      showClearButton: true,
      autoFocus: false,
      disabled: false,
      showTodayButton: true,
      overlayContainerLeft: '',
      overlayContainerRight: '',
      todayButtonLabel: "Today",
      autoComplete: "on",
      showWeeks: false,
      overlayContainerCustomVal: '',
      popOverArrowLeft: '35%',
      instanceCount: instanceCount++,
      style: {
        width: "100%"
      },
      roundedCorners: false,
      noValidate: false
    };
  },
  getInitialState: function getInitialState() {
    if (this.props.value && this.props.defaultValue) {
      throw new Error("Conflicting DatePicker properties 'value' and 'defaultValue'");
    }
    var state = this.makeDateValues(this.props.value || this.props.defaultValue);
    if (this.props.weekStartsOn > 1) {
      state.dayLabels = this.props.dayLabels.slice(this.props.weekStartsOn).concat(this.props.dayLabels.slice(0, this.props.weekStartsOn));
    } else if (this.props.weekStartsOn === 1) {
      state.dayLabels = this.props.dayLabels.slice(1).concat(this.props.dayLabels.slice(0, 1));
    } else {
      state.dayLabels = this.props.dayLabels;
    }
    state.focused = false;
    state.inputFocused = false;
    state.placeholder = this.props.placeholder || this.props.dateFormat;
    state.separator = this.props.dateFormat.match(/[^A-Z]/)[0];
    return state;
  },
  makeDateValues: function makeDateValues(isoString) {
    var displayDate;
    var selectedDate = isoString ? new Date("".concat(isoString.slice(0, 10), "T12:00:00.000Z")) : null;
    var minDate = this.props.minDate ? new Date("".concat(this.props.minDate.slice(0, 10), "T12:00:00.000Z")) : null;
    var maxDate = this.props.maxDate ? new Date("".concat(this.props.maxDate.slice(0, 10), "T12:00:00.000Z")) : null;
    var inputValue = isoString ? this.makeInputValueString(selectedDate) : null;
    if (selectedDate) {
      displayDate = new Date(selectedDate);
    } else {
      var today = new Date("".concat(new Date().toISOString().slice(0, 10), "T12:00:00.000Z"));
      if (minDate && Date.parse(minDate) >= Date.parse(today)) {
        displayDate = minDate;
      } else if (maxDate && Date.parse(maxDate) <= Date.parse(today)) {
        displayDate = maxDate;
      } else {
        displayDate = today;
      }
    }
    return {
      value: selectedDate ? selectedDate.toISOString() : null,
      displayDate: displayDate,
      selectedDate: selectedDate,
      inputValue: inputValue
    };
  },
  clear: function clear() {
    if (this.props.onClear) {
      this.props.onClear();
    } else {
      this.setState(this.makeDateValues(null));
    }
    if (this.props.onChange) {
      this.props.onChange(null, null);
    }
  },
  handleHide: function handleHide() {
    if (this.state.inputFocused) {
      return;
    }
    this.setState({
      focused: false
    });
    if (this.props.onBlur) {
      var event = document.createEvent("CustomEvent");
      event.initEvent("Change Date", true, false);
      _reactDom.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
      this.props.onBlur(event);
    }
  },
  handleKeyDown: function handleKeyDown(e) {
    if (e.which === 9 && this.state.inputFocused) {
      this.setState({
        focused: false
      });
      if (this.props.onBlur) {
        var event = document.createEvent("CustomEvent");
        event.initEvent("Change Date", true, false);
        _reactDom.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
        this.props.onBlur(event);
      }
    }
  },
  handleFocus: function handleFocus() {
    if (this.state.focused === true) {
      return;
    }
    var placement = this.getCalendarPlacement();
    this.setState({
      inputFocused: true,
      focused: true,
      calendarPlacement: placement
    });
    if (this.props.onFocus) {
      var event = document.createEvent("CustomEvent");
      event.initEvent("Change Date", true, false);
      _reactDom.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
      this.props.onFocus(event);
    }
  },
  handleBlur: function handleBlur() {
    this.setState({
      inputFocused: false
    });
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return !(this.state.inputFocused === true && nextState.inputFocused === false);
  },
  getValue: function getValue() {
    return this.state.selectedDate ? this.state.selectedDate.toISOString() : null;
  },
  getFormattedValue: function getFormattedValue() {
    return this.state.displayDate ? this.state.inputValue : null;
  },
  getCalendarPlacement: function getCalendarPlacement() {
    var tag = Object.prototype.toString.call(this.props.calendarPlacement);
    var isFunction = tag === "[object AsyncFunction]" || tag === "[object Function]" || tag === "[object GeneratorFunction]" || tag === "[object Proxy]";
    if (isFunction) {
      return this.props.calendarPlacement();
    } else {
      return this.props.calendarPlacement;
    }
  },
  makeInputValueString: function makeInputValueString(date) {
    var month = date.getMonth() + 1;
    var day = date.getDate();

    //this method is executed during intialState setup... handle a missing state properly
    var separator = this.state ? this.state.separator : this.props.dateFormat.match(/[^A-Z]/)[0];
    if (this.props.dateFormat.match(/MM.DD.YYYY/)) {
      return (month > 9 ? month : "0".concat(month)) + separator + (day > 9 ? day : "0".concat(day)) + separator + date.getFullYear();
    } else if (this.props.dateFormat.match(/DD.MM.YYYY/)) {
      return (day > 9 ? day : "0".concat(day)) + separator + (month > 9 ? month : "0".concat(month)) + separator + date.getFullYear();
    } else {
      return date.getFullYear() + separator + (month > 9 ? month : "0".concat(month)) + separator + (day > 9 ? day : "0".concat(day));
    }
  },
  handleBadInput: function handleBadInput(originalValue) {
    var parts = originalValue.replace(new RegExp("[^0-9".concat(this.state.separator, "]")), "").split(this.state.separator);
    if (this.props.dateFormat.match(/MM.DD.YYYY/) || this.props.dateFormat.match(/DD.MM.YYYY/)) {
      if (parts[0] && parts[0].length > 2) {
        parts[1] = parts[0].slice(2) + (parts[1] || "");
        parts[0] = parts[0].slice(0, 2);
      }
      if (parts[1] && parts[1].length > 2) {
        parts[2] = parts[1].slice(2) + (parts[2] || "");
        parts[1] = parts[1].slice(0, 2);
      }
      if (parts[2]) {
        parts[2] = parts[2].slice(0, 4);
      }
    } else {
      if (parts[0] && parts[0].length > 4) {
        parts[1] = parts[0].slice(4) + (parts[1] || "");
        parts[0] = parts[0].slice(0, 4);
      }
      if (parts[1] && parts[1].length > 2) {
        parts[2] = parts[1].slice(2) + (parts[2] || "");
        parts[1] = parts[1].slice(0, 2);
      }
      if (parts[2]) {
        parts[2] = parts[2].slice(0, 2);
      }
    }
    this.setState({
      inputValue: parts.join(this.state.separator)
    });
  },
  handleInputChange: function handleInputChange() {
    var originalValue = _reactDom.default.findDOMNode(this.input).value;
    var inputValue = originalValue.replace(/(-|\/\/)/g, this.state.separator).slice(0, 10);
    if (!inputValue) {
      this.clear();
      return;
    }
    var month, day, year;
    if (this.props.dateFormat.match(/MM.DD.YYYY/)) {
      if (!inputValue.match(/[0-1][0-9].[0-3][0-9].[1-2][0-9][0-9][0-9]/)) {
        return this.handleBadInput(originalValue);
      }
      month = inputValue.slice(0, 2).replace(/[^0-9]/g, "");
      day = inputValue.slice(3, 5).replace(/[^0-9]/g, "");
      year = inputValue.slice(6, 10).replace(/[^0-9]/g, "");
    } else if (this.props.dateFormat.match(/DD.MM.YYYY/)) {
      if (!inputValue.match(/[0-3][0-9].[0-1][0-9].[1-2][0-9][0-9][0-9]/)) {
        return this.handleBadInput(originalValue);
      }
      day = inputValue.slice(0, 2).replace(/[^0-9]/g, "");
      month = inputValue.slice(3, 5).replace(/[^0-9]/g, "");
      year = inputValue.slice(6, 10).replace(/[^0-9]/g, "");
    } else {
      if (!inputValue.match(/[1-2][0-9][0-9][0-9].[0-1][0-9].[0-3][0-9]/)) {
        return this.handleBadInput(originalValue);
      }
      year = inputValue.slice(0, 4).replace(/[^0-9]/g, "");
      month = inputValue.slice(5, 7).replace(/[^0-9]/g, "");
      day = inputValue.slice(8, 10).replace(/[^0-9]/g, "");
    }
    var monthInteger = parseInt(month, 10);
    var dayInteger = parseInt(day, 10);
    var yearInteger = parseInt(year, 10);
    if (monthInteger > 12 || dayInteger > 31) {
      return this.handleBadInput(originalValue);
    }
    if (!isNaN(monthInteger) && !isNaN(dayInteger) && !isNaN(yearInteger) && monthInteger <= 12 && dayInteger <= 31 && yearInteger > 999) {
      var selectedDate = new Date(yearInteger, monthInteger - 1, dayInteger, 12, 0, 0, 0);
      this.setState({
        selectedDate: selectedDate,
        displayDate: selectedDate,
        value: selectedDate.toISOString()
      });
      if (this.props.onChange) {
        this.props.onChange(selectedDate.toISOString(), inputValue);
      }
    }
    this.setState({
      inputValue: inputValue
    });
  },
  onChangeMonth: function onChangeMonth(newDisplayDate) {
    this.setState({
      displayDate: newDisplayDate
    });
  },
  onChangeDate: function onChangeDate(newSelectedDate) {
    var inputValue = this.makeInputValueString(newSelectedDate);
    this.setState({
      inputValue: inputValue,
      selectedDate: newSelectedDate,
      displayDate: newSelectedDate,
      value: newSelectedDate.toISOString(),
      focused: false
    });
    if (this.props.onBlur) {
      var event = document.createEvent("CustomEvent");
      event.initEvent("Change Date", true, false);
      _reactDom.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
      this.props.onBlur(event);
    }
    if (this.props.onChange) {
      this.props.onChange(newSelectedDate.toISOString(), inputValue);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
    var value = newProps.value;
    if (this.getValue() !== value) {
      this.setState(this.makeDateValues(value));
    }
  },
  render: function render() {
    var _this$props2,
      _this$props3,
      _this2 = this;
    var _this$props = this.props,
      position = _this$props.position,
      verticalPlacement = _this$props.verticalPlacement;
    var overlayContainerLeft = '';
    var overlayContainerRight = '';
    var popoverRight = '';
    var popoverLeft = '';
    var overlayContainerTop = '';
    var overlayContainerBottom = '';
    var overlayContainerTransform = '';
    switch (position) {
      case 'right':
        overlayContainerLeft = 'unset';
        overlayContainerRight = '0';
        popoverRight = '35%';
        popoverLeft = 'unset';
        break;
      case 'center':
        overlayContainerLeft = 'unset';
        overlayContainerRight = '-25%';
        popoverRight = '35%';
        popoverLeft = 'unset';
        break;
      case 'custom':
        overlayContainerLeft = (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.overlayContainerLeft;
        overlayContainerRight = 'unset';
        popoverRight = (_this$props3 = this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.popoverRight;
        popoverLeft = 'unset';
        break;
      default:
        overlayContainerLeft = '0';
        overlayContainerRight = 'unset';
        popoverRight = 'unset';
        popoverLeft = '35%';
    }
    if (verticalPlacement === 'top') {
      overlayContainerTop = 'unset';
      overlayContainerBottom = '0';
      overlayContainerTransform = 'translate(-2px, -15%);';
    } else if (verticalPlacement === 'custom') {
      var _this$props4;
      overlayContainerTop = (_this$props4 = this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.overlayContainerTop;
      overlayContainerBottom = 'unset';
      overlayContainerTransform = 'translate(-2px, 15%);';
    } else {
      overlayContainerTop = '0';
      overlayContainerBottom = 'unset';
      overlayContainerTransform = 'translate(-2px, 15%);';
    }
    var DatePickerWrapper = _styledComponents.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n.datepicker-overlay-container {\n  position: absolute;\n  z-index: 99;\n  left: ", " !important;\n  top: ", " !important;\n  bottom:", " !important;\n  transform: ", " !important;\n  right:", " !important;\n  .date-picker-popover.bs-popover-bottom {\n    position: relative !important;\n    transform: unset !important;\n  }\n}\n  .today-button {\n    background-color: transparent;\n    border-color: transparent;\n    background-image: unset;\n    color: #337ab7;\n    font-size: 15px;\n    box-shadow: unset;\n    width: 100%;\n    padding: 7px 10px;\n    border-radius: 3px;\n    &:hover {\n      cursor: pointer;\n    }\n    &:focus {\n      outline: none;\n    }\n  }\n  .heading {\n    margin: 0px;\n  }\n  .heading .text-center {\n    display: flex;\n    justify-content: space-between;\n    font-size: 14px;\n    background-color: #f7f7f7;\n    border-bottom: 1px solid #ebebeb;\n    border-radius: 5px 5px 0 0;\n    padding: 13px 14px;\n  }\n  .input {\n    border: 1px solid #ccc;\n    display: flex;\n    border-radius: 4px;\n    position: relative;\n  }\n  .input .form-control {\n    position: relative;\n    border-color: transparent;\n    height: 100%;\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n  .input .input-group-text {\n    margin-top: 0px !important;\n    border-radius: 0px;\n    border-color: transparent;\n    border-left-color: #ccc;\n    line-height: 18px;\n  }\n  .selected-date-background {\n    color: #fff;\n    background-color: #337ab7;\n  }\n  .selected-date-text {\n    color: #337ab7;\n  }\n  .popover-arrow {\n    position: absolute !important;\n    right: ", " !important;\n    left: ", " !important;\n   \n    \n    transform: translate(-35%, 0px) !important;\n    &::before {\n      border-right: 6px solid transparent;\n      border-bottom: 8px solid #0000002d;\n      border-left: 6px solid transparent;\n    }\n    &::after {\n      border-right: 6px solid transparent;\n      border-bottom: 9px solid #f7f7f7;\n      border-left: 6px solid transparent;\n    }\n  }\n\n  .heading span {\n    font-size: 20px;\n    font-weight: 400;\n  }\n  .date-picker-style.form-control::placeholder {\n    font-size: 16px;\n  }\n  .popover-body{\n    padding: 10px 20px;\n  }\n  .today-button{\n    padding : 0px;\n  }\n"])), overlayContainerLeft, overlayContainerTop, overlayContainerBottom, overlayContainerTransform, overlayContainerRight, popoverRight, popoverLeft);
    var calendarHeader = /*#__PURE__*/_react.default.createElement(CalendarHeader, {
      previousButtonElement: this.props.previousButtonElement,
      nextButtonElement: this.props.nextButtonElement,
      displayDate: this.state.displayDate,
      minDate: this.props.minDate,
      maxDate: this.props.maxDate,
      onChange: this.onChangeMonth,
      monthLabels: this.props.monthLabels,
      dateFormat: this.props.dateFormat
    });
    var control = this.props.customControl ? /*#__PURE__*/_react.default.cloneElement(this.props.customControl, {
      onKeyDown: this.handleKeyDown,
      value: this.state.inputValue || "",
      required: this.props.required,
      placeholder: this.state.focused ? this.props.dateFormat : this.state.placeholder,
      ref: "input",
      disabled: this.props.disabled,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onChange: this.handleInputChange,
      className: this.props.className,
      style: this.props.style,
      autoComplete: this.props.autoComplete,
      onInvalid: this.props.onInvalid,
      noValidate: this.props.noValidate
    }) : /*#__PURE__*/_react.default.createElement(_FormControl.default, {
      onKeyDown: this.handleKeyDown,
      value: this.state.inputValue || "",
      required: this.props.required,
      ref: function ref(_ref) {
        return _this2.input = _ref;
      },
      type: "text",
      className: this.props.className,
      style: this.props.style,
      autoFocus: this.props.autoFocus,
      disabled: this.props.disabled,
      placeholder: this.state.focused ? this.props.dateFormat : this.state.placeholder,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onChange: this.handleInputChange,
      autoComplete: this.props.autoComplete,
      onInvalid: this.props.onInvalid,
      noValidate: this.props.noValidate
    });
    this.overlayContainerRef = /*#__PURE__*/_react.default.createRef();
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: function ref(_ref2) {
        return _this2.datePickerRef = _ref2;
      }
    }, /*#__PURE__*/_react.default.createElement(DatePickerWrapper, {
      className: this.props.className,
      position: this.props.position,
      overlayContainerLeft: this.props.overlayContainerLeft,
      overlayContainerTop: this.props.overlayContainerTop,
      popoverRight: this.props.popoverRight,
      verticalPlacement: this.props.verticalPlacement
    }, /*#__PURE__*/_react.default.createElement(_InputGroup.default, {
      bsPrefix: "input",
      ref: "inputGroup",
      bsClass: this.props.showClearButton ? this.props.bsClass : "",
      bsSize: this.props.bsSize,
      id: this.props.id ? "".concat(this.props.id, "_group") : null,
      style: {
        width: "100%"
      }
    }, control, /*#__PURE__*/_react.default.createElement(_Overlay.default, {
      rootClose: true,
      onHide: this.handleHide,
      show: this.state.focused,
      container: function container() {
        return _this2.props.calendarContainer || _this2.overlayContainerRef;
      },
      target: function target() {
        var _this2$input;
        return (_this2$input = _this2.input) === null || _this2$input === void 0 ? void 0 : _this2$input.current;
      },
      placement: this.state.calendarPlacement,
      delayHide: 200
    }, /*#__PURE__*/_react.default.createElement(_Popover.default, {
      id: "date-picker-popover-".concat(this.props.instanceCount),
      className: "date-picker-popover"
    }, /*#__PURE__*/_react.default.createElement(_Popover.default.Header, {
      as: "h3",
      bsPrefix: "heading"
    }, calendarHeader), /*#__PURE__*/_react.default.createElement(_Popover.default.Body, null, /*#__PURE__*/_react.default.createElement(Calendar, {
      cellPadding: this.props.cellPadding,
      selectedDate: this.state.selectedDate,
      displayDate: this.state.displayDate,
      onChange: this.onChangeDate,
      dayLabels: this.state.dayLabels,
      weekStartsOn: this.props.weekStartsOn,
      showTodayButton: this.props.showTodayButton,
      todayButtonLabel: this.props.todayButtonLabel,
      minDate: this.props.minDate,
      maxDate: this.props.maxDate,
      roundedCorners: this.props.roundedCorners,
      showWeeks: this.props.showWeeks,
      calendarPlacement: "top"
    })))), /*#__PURE__*/_react.default.createElement("div", {
      ref: this.overlayContainerRef,
      className: "datepicker-overlay-container"
    }), /*#__PURE__*/_react.default.createElement("input", {
      ref: "hiddenInput",
      type: "hidden",
      id: this.props.id,
      name: this.props.name,
      value: this.state.value || "",
      "data-formattedvalue": this.state.value ? this.state.inputValue : ""
    }), this.props.showClearButton && !this.props.customControl &&
    /*#__PURE__*/
    //   <InputGroup.Addon
    _react.default.createElement(_InputGroup.default.Text, {
      id: "basic-addon1",
      onClick: this.props.disabled ? null : this.clear,
      style: {
        cursor: this.state.inputValue && !this.props.disabled ? "pointer" : "not-allowed"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        opacity: this.state.inputValue && !this.props.disabled ? 1 : 0.5
      }
    }, this.props.clearButtonElement))
    //   </InputGroup.Addon>
    , this.props.children)));
  }
});
var _default = CustomDatePicker;
exports.default = _default;